import { Colors, Lightning } from '@lightningjs/sdk'

export default class ReadmoreScroller extends Lightning.Component {
  static _template() {
    return {
      ScrollerWrapper: {
        w: w => w,
        h: h => h,
        MainBar: {
          w: w => w,
          h: h => h,
          rtt: true,
          rect: true,
          shader: {
            type: Lightning.shaders.RoundedRectangle,
            w: w => w,
            h: h => h,
            fillColor: Colors('lBlue').get(),
          },
        },
        ScrollPart: {
          x: 1,
          y: 1,
          w: w => w - 2,
          h: 19,
          rect: true,
          shader: {
            type: Lightning.shaders.RoundedRectangle,
            w: w => w - 4,
            h: 19,
            fillColor: Colors('white').get(),
          },
        },
      },
    }
  }

  set steps(st) {
    if (Number(st) > 0) {
      this.totalSteps = st + 1
      this._scrollerHeight = this.h / this.totalSteps

      this.tag('ScrollPart').h = this._scrollerHeight

      this.visible = true
    } else {
      this.visible = false
    }
  }

  set position(pos) {
    this._pos = pos

    this.tag('ScrollPart').setSmooth('y', pos * this._scrollerHeight, {
      duration: 0.3,
      timingFunction: 'ease-out',
    })
  }

  get position() {
    return this._pos
  }

  get scrollerHeight() {
    return this._scrollerHeight
  }

  set focusScrollPart(bool) {
    this.tag('ScrollPart').setSmooth('alpha', bool === true ? 1 : 0.4, {
      duration: 0.2,
      timingFunction: 'ease-in',
    })
  }
}
